const NAME = "ASSISTANCE_PAGE";

export default NAME;
